import { Button } from "@/ui";
import { formatMonth, shiftMonth } from "./ledger";

const PREV = "‹";
const NEXT = "›";

const TODAY_CAPTION = "this month";

type MonthStepperProps = {
  month: string;
  onChange: (month: string) => void;
  /** The month "today" falls in — captioned so the present is findable at a glance. */
  currentMonth: string;
};

/**
 * Steps the page's period one month at a time.
 *
 * The label has a fixed width so the arrows never shuffle sideways under the cursor
 * as the month name changes length, and the "this month" caption is positioned out
 * of the flow so its presence or absence cannot move anything either.
 */
export function MonthStepper({ month, onChange, currentMonth }: MonthStepperProps) {
  return (
    <div className="month-nav">
      <Button
        type="button"
        variant="secondary"
        size="sm"
        aria-label={`Previous month, ${formatMonth(shiftMonth(month, -1))}`}
        onClick={() => onChange(shiftMonth(month, -1))}
      >
        {PREV}
      </Button>

      <span className="month-label">
        <span className="month-name">{formatMonth(month)}</span>
        {month === currentMonth && <span className="month-today">{TODAY_CAPTION}</span>}
      </span>

      <Button
        type="button"
        variant="secondary"
        size="sm"
        aria-label={`Next month, ${formatMonth(shiftMonth(month, 1))}`}
        onClick={() => onChange(shiftMonth(month, 1))}
      >
        {NEXT}
      </Button>
    </div>
  );
}
